import { create } from 'zustand';

import type { IEmailPlansSlice } from '../slices';
import { createEmailPlansSlice } from '../slices';

export type ILegacyPayflowPage = IEmailPlansSlice;

export const useLegacyPayflowPageStore = create<ILegacyPayflowPage>()((...args) => ({
  ...createEmailPlansSlice(...args),
}));
